import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import faqConfig from '../config/faqConfig.json';
import SEO from '../components/SEO';

const FAQ = () => {
  const { faqs } = faqConfig;
  const [expanded, setExpanded] = useState(null);

  const sections = [
    {
      title: 'Consultation',
      items: faqs.filter((item) => [1].includes(item.id))
    },
    {
      title: 'Acne & Skin Health',
      items: faqs.filter((item) => [2, 3, 4].includes(item.id))
    },
    {
      title: 'Injectables & Aesthetic Treatments',
      items: faqs.filter((item) => [5, 6, 7, 8].includes(item.id))
    },
    {
      title: 'Practical Questions',
      items: faqs.filter((item) => [9, 10, 11, 13, 14, 15, 16, 17].includes(item.id))
    },
    {
      title: 'Booking & Cancellation',
      items: faqs.filter((item) => [12].includes(item.id))
    }
  ].filter((section) => section.items.length > 0);

  return (
    <section className="faq">
      <SEO
        title="Skincare FAQ | ART Aesthetics & Skincare Widnes"
        description="Answers to common questions about consultations, acne treatment, injectables, bookings, and aftercare at ART Aesthetics & Skincare."
        path="/faq"
      />
      <div className="faq-container">
        <h1 className="page-title">Frequently Asked Questions</h1>
        <p className="page-subtitle">Find answers to common questions about our services</p>
        <div className="faq-policy-callout">
          <p>Need policy details quickly?</p>
          <Link to="/booking-policy" className="faq-policy-link">
            Booking &amp; Cancellation Policy
          </Link>
        </div>
        <div className="faq-list">
          {sections.map((section) => (
            <div key={section.title} className="faq-section">
              <h2 className="faq-section-title">{section.title}</h2>
              {section.items.map((item) => (
                <motion.div
                  key={item.id}
                  className="faq-item"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  <button
                    className={`faq-question ${expanded === item.id ? 'active' : ''}`}
                    onClick={() => setExpanded(expanded === item.id ? null : item.id)}
                  >
                    <span>{item.question}</span>
                    <span className="toggle-icon">{expanded === item.id ? '−' : '+'}</span>
                  </button>
                  <AnimatePresence>
                    {expanded === item.id && (
                      <motion.div
                        className="faq-answer"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <p>{item.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
